/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';

export interface DashboardApiResponse {
    statusCode: number;
    data: {
        TotalOutstandingBalance: number;
        UpcomingPayments: number;
        ServiceRequests: number;
        ActiveContracts: number;
        LastRetrievalTime: string;
    };
    message?: string;
}

export const getDashboardData = async (showLoader: boolean = true): Promise<DashboardApiResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: api_urls.GetDashboardData,
            showLoader,
        });
        return response?.data;
    } catch (error: any) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};
